import React from 'react'

import SignUp from '../components/SignUp/SignUp'

const SignUpPage = () => {
  return (
    <SignUp />
  )
}

export default SignUpPage